import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { useMediaQuery } from 'react-responsive';
import alertBg from 'images/alertBg.svg';
import './index.css';

const ModalBody = styled.div`
    font-size: 14px;
    font-weight: normal; 
    padding: 4px 16px;
`;

const ModalHeader = styled.div<any>`
    .title{
        font-size: 18px;
        padding: 16px 0 16px 16px;
        border-bottom: ${(props) => props.isTitleBordered ? '1px solid #eee' : 'none'};

    }
`;

interface ModalProps {
    title?: string;
    modalBody: JSX.Element | String;
    closable?: boolean;
    onCancel?: Function;
    footerButtons?: any;
    customHeader?: boolean;
    isTitleBordered?: boolean;
}

const ConfirmationModal: React.FC<ModalProps> = (props: ModalProps) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return (

        <Modal
            zIndex={ 9999 }
            // title={ props?.title }
            centered
            visible={ true }
            closable={ props.closable }
            onCancel={ () => {
                if (props.onCancel) props.onCancel();
            } }
            width={ isMobile? '90vw' : 376 }
            footer={
                props.footerButtons ?? null
            }
        >    
            <ModalHeader isTitleBordered={props?.isTitleBordered}>
                {props?.customHeader && <img src={alertBg} className='alertBg' alt='alert'/>}
                <p className = { props?.customHeader ? 'title-bg-primary' : 'title'}>{ props?.title }</p>
            </ModalHeader>
            <ModalBody>{ props.modalBody }</ModalBody>

        </Modal>
    )

}

export default ConfirmationModal;